var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-select',{attrs:{"options":_vm.selectForm.options},on:{"change":_vm.filterByRegion},model:{value:(_vm.selectForm.value),callback:function ($$v) {_vm.$set(_vm.selectForm, "value", $$v)},expression:"selectForm.value"}})}
var staticRenderFns = []

export { render, staticRenderFns }